#import "../../common/graphql/EntityUserMessageFields.graphql"
#import "../../common/graphql/ExtendedMessageFields.graphql"
query GetUserMessages(
  $first: Int
  $after: Cursor
  $offset: Int
  $filter: UserMessageFilter
) {
  userMessages(
    first: $first
    after: $after
    offset: $offset
    orderBy: [_SORT_DATE_DESC, _CREATED_DATE_DESC]
    filter: $filter
  ) {
    nodes {
      ...EntityUserMessageFields
      ...ExtendedMessageFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
